module.exports = __webpack_public_path__ + "img/rezkit-core-logo.7ae9ce8.svg";